<template>
  <div>
    <main-layout>
      <v-container>
        <h1>
          {{ $t('sales_booster') }}
          <a :href="`https://blog.zwiz.app/growth-tools/`" target="blank"
            ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
          ></a>
        </h1>
        <v-layout
          wrap
          style="display: inline-flex;"
          :style="this.$vuetify.breakpoint.xs ? 'white:100%' : 'width: 100%'"
        >
          <template v-for="(list, index) in data">
            <v-flex sm6 xs12 lg4 class="px-2 py-3" :key="index">
              <div class="card-package-yellow z-border-red" style="padding: 25px 20px 25px 20px;">
                <h2 class="mb-0 black-color" style="min-height: 94px;">
                  {{ index + 1 }}. {{ list.title }}
                  <a :href="list.url" target="blank"
                    ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
                  ></a>
                </h2>
                <!-- <div class="caption mb-2">(90 {{ $t('Days') }})</div> -->

                <img
                  style="width: 100%;"
                  :src="currentLang === 'th' ? list.image : list.imageEng"
                  alt=""
                />

                <div class="text-xs-center mt-2">
                  <p style="min-height: 115px;">
                    {{ list.subtitle }}
                  </p>
                  <v-btn
                    style="width:100%; font-size:16px"
                    class="mt-3"
                    dark
                    color="primary"
                    depressed
                    @click="
                      list.description.url = list.url
                      description = list.description
                      dialog = true
                    "
                  >
                    {{ $t('more_details') }}
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </template>
        </v-layout>
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-text>
              <v-layout style="align-items: center;">
                <v-flex sm10>
                  <h2 class="mb-3 black-color">{{ description.title }}</h2>
                </v-flex>
                <v-flex sm2>
                  <div class="text-xs-right">
                    <v-btn small fab flat @click="dialog = false"><v-icon>close</v-icon></v-btn>
                  </div>
                </v-flex>
              </v-layout>

              <p style="text-indent: 30px;">{{ description.text }}</p>
              <p style="text-indent: 30px;">
                {{ description.text1 }}
              </p>
              <p style="text-indent: 30px;">{{ description.text2 }}</p>
              <ul class="mb-2">
                <li class="ml-3" v-for="(subDescription, index) in description.list" :key="index">
                  <template v-if="subDescription !== ''"> - {{ subDescription }} </template>
                </li>
              </ul>
              <p>
                {{ description.imageText }}
              </p>
              <template v-if="description.image">
                <img
                  style="width: 60%;"
                  :src="currentLang === 'th' ? description.imageTh : description.image"
                  alt=""
                />
              </template>
              <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
                >{{ $t('link_copied') }}!</v-snackbar
              >
              <div v-if="!loading && description.isShowRefLink">
                <div class="mt-2">
                  <span>{{ $t('selected_conversation') }}</span>
                  <multiselect
                    v-model="intentSelect"
                    :options="intents"
                    label="label"
                    selectLabel
                    selectedLabel
                    :allow-empty="true"
                    :searchable="false"
                    deselect-label
                    track-by="label"
                    @select="onSelect"
                  ></multiselect>
                </div>
                <div class="mt-2">
                  <span>{{ $t('Share_Ref_link') }}</span>
                  <textarea
                    class="form-control pa-1"
                    ref="shareLink"
                    style="resize: vertical; width: 100%; border: 1px solid #eee;"
                    readonly="true"
                    v-model="intentSelect.value"
                  ></textarea>
                  <div class="text-xs-center">
                    <v-btn
                      depressed
                      color="primary"
                      v-clipboard:copy="intentSelect.value"
                      v-clipboard:success="onCopy"
                    >
                      <span class="glyphicon glyphicon-file mr-1"></span>
                      {{ $t('copy') }}
                    </v-btn>
                  </div>
                </div>
              </div>
              <p style="color: cornflowerblue">{{ description.packageText }}</p>
              <p>
                {{ $t('how_to_set') }}
                <a :href="description.url" target="_blank">{{ $t('click') }}</a>
              </p>
              <p v-if="description.goToLandingPage">
                {{ $t('for_ads_beginner_read_more_information') }}
                <a
                  :href="
                    `https://zwiz.ai/${currentLang}/ads?utm_source=CMS&pageid=${selectedBot.pageid}`
                  "
                  target="_blank"
                  >{{ $t('here') }}</a
                >
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  components: { Multiselect },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
      // loading: 'getLoadingIntents'
    }),

    intents() {
      var a = []
      this.$store.getters.getIntents('intent').map(item => {
        var pointer = null
        var keyword = item.q_val.split(',')[0]
        if (
          (keyword.startsWith('startswith(') && keyword.endsWith(')')) ||
          (keyword.startsWith('endswith(') && keyword.endsWith(')')) ||
          (keyword.startsWith('startsendswith(') && keyword.endsWith(')')) ||
          (keyword.startsWith('includes(') && keyword.endsWith(')')) ||
          (keyword.startsWith('exacts(') && keyword.endsWith(')'))
        ) {
          // startswith(...)
          pointer = keyword.search(/\(/g)
          keyword = keyword.substring(pointer + 1, keyword.length - 1)
          keyword = keyword.replace('&&', ' ')
          a.push({
            label: item.intentname,
            value: `https://m.me/${this.selectedBot.pageid}?ref=${keyword}`
          })
        } else {
          keyword = keyword.replace('&&', ' ')
          a.push({
            label: item.intentname,
            value: `https://m.me/${this.selectedBot.pageid}?ref=${keyword}`
          })
        }
      })
      return a
    }
  },
  data() {
    return {
      loading: true,
      showCopy: false,
      intentSelect: {},
      dialog: false,
      description: {},
      data: [
        {
          title: this.$t('growthtool_title_10'),
          subtitle: this.$t('growthtool_subtitle_10'),
          image: '/static/img/assets/growthtool/ads simu-03.jpeg',
          imageEng: '/static/img/assets/growthtool/ads simu-04.jpeg',
          description: {
            list: [
              this.$t('growthtool_description_list_10'),
              this.$t('growthtool_description_list1_10'),
              this.$t('growthtool_description_list2_10')
            ],
            title: this.$t('growthtool_description_title_10'),
            text: this.$t('growthtool_description_text_10'),
            text1: this.$t('growthtool_description_text1_10'),
            packageText: this.$t('growthtool_description_packageText_10'),
            imageText: this.$t('growthtool_description_text2_10'),
            goToLandingPage: true
          },
          url: 'https://blog.zwiz.app/messenger-ads-simulator/'
        },
        {
          title: this.$t('growthtool_title_11'),
          subtitle: this.$t('growthtool_subtitle_11'),
          image: '/static/img/assets/growthtool/verify-03.jpeg',
          imageEng: '/static/img/assets/growthtool/verify-04.jpeg',
          description: {
            list: [
              this.$t('growthtool_description_list_11'),
              this.$t('growthtool_description_list1_11'),
              this.$t('growthtool_description_list2_11'),
              this.$t('growthtool_description_list3_11')
            ],
            title: this.$t('growthtool_description_title_11'),
            text: this.$t('growthtool_description_text_11'),
            text1: this.$t('growthtool_description_text1_11'),
            packageText: this.$t('growthtool_description_packageText_11'),
            imageText: this.$t('growthtool_description_text2_11')
          },
          url: 'https://blog.zwiz.app/slip-verification/'
        },
        {
          title: this.$t('growthtool_title_06'),
          subtitle: this.$t('growthtool_subtitle_06'),
          image: '/static/img/assets/growthtool/Growth_tools_08.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_14.jpg',
          description: {
            title: this.$t('growthtool_description_title_06'),
            text: this.$t('growthtool_description_text_06'),
            text1: this.$t('growthtool_description_text1_06'),
            list: [
              this.$t('growthtool_description_list_06'),
              this.$t('growthtool_description_list1_06')
            ],
            packageText: this.$t('growthtool_description_packageText_06')
          },
          url: 'https://blog.zwiz.app/chatbotonweb/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_01'),
          subtitle: this.$t('growthtool_subtitle_01'),
          image: '/static/img/assets/growthtool/Growth_tools_03.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_12.jpg',
          description: {
            title: this.$t('growthtool_description_title_01'),
            text: this.$t('growthtool_description_text_01'),
            text1: this.$t('growthtool_description_text1_01'),
            packageText: this.$t('growthtool_description_packageText_01')
          },
          url:
            'https://blog.zwiz.app/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%AD%E0%B8%9A%E0%B8%81%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B8%84%E0%B8%AD%E0%B8%A1%E0%B9%80%E0%B8%A1%E0%B8%99%E0%B8%95%E0%B9%8C/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_05'),
          subtitle: this.$t('growthtool_subtitle_05'),
          image: '/static/img/assets/growthtool/Growth_tools_07.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_18.jpg',
          description: {
            title: this.$t('growthtool_description_title_05'),
            text: this.$t('growthtool_description_text_05'),
            text1: this.$t('growthtool_description_text1_05'),
            packageText: this.$t('growthtool_description_packageText_05'),
            image: '/static/img/assets/growthtool/2.jpeg',
            imageTh: '/static/img/assets/growthtool/4.jpg',
            imageText: this.$t('growthtool_description_imageText_05')
          },
          url:
            'https://blog.zwiz.app/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%AA%E0%B8%96%E0%B8%B2%E0%B8%99%E0%B8%B0status-%E0%B8%9B%E0%B9%89%E0%B8%B2%E0%B8%A2%E0%B8%81%E0%B8%B3%E0%B8%81%E0%B8%B1%E0%B8%9Atag/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_08'),
          subtitle: this.$t('growthtool_subtitle_08'),
          image: '/static/img/assets/growthtool/Growth_tools_02.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_11.jpg',
          description: {
            title: this.$t('growthtool_description_title_08'),
            text: this.$t('growthtool_description_text_08'),
            list: [
              this.$t('growthtool_description_list_08'),
              this.$t('growthtool_description_list1_08'),
              this.$t('growthtool_description_list2_08'),
              this.$t('growthtool_description_list3_08')
            ],
            packageText: this.$t('growthtool_description_packageText_08'),
            goToLandingPage: true
          },
          url: 'https://blog.zwiz.app/custom-audience/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_07'),
          subtitle: this.$t('growthtool_subtitle_07'),
          image: '/static/img/assets/growthtool/Growth_tools_01.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_10.jpg',
          description: {
            title: this.$t('growthtool_description_title_07'),
            text: this.$t('growthtool_description_text_07'),
            text1: this.$t('growthtool_description_text1_07'),
            text2: this.$t('growthtool_description_text2_07'),
            packageText: this.$t('growthtool_description_packageText_07'),
            goToLandingPage: true
          },
          url:
            'https://blog.zwiz.app/%E0%B8%A7%E0%B8%B4%E0%B8%98%E0%B8%B5%E0%B8%95%E0%B8%B1%E0%B9%89%E0%B8%87%E0%B8%84%E0%B9%88%E0%B8%B2fb-ad/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_09'),
          subtitle: this.$t('growthtool_subtitle_09'),
          image: '/static/img/assets/growthtool/Growth_tools_19.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_20.jpg',
          description: {
            title: this.$t('growthtool_description_title_09'),
            text: this.$t('growthtool_description_text_09'),
            text1: this.$t('growthtool_description_text1_09'),
            text2: this.$t('growthtool_description_text2_09'),
            list: [
              this.$t('growthtool_description_list_09'),
              this.$t('growthtool_description_list1_09'),
              this.$t('growthtool_description_list2_09'),
              this.$t('growthtool_description_list3_09')
            ],
            packageText: this.$t('growthtool_description_packageText_09')
          },
          url:
            'https://blog.zwiz.app/%E0%B8%AA%E0%B8%B9%E0%B8%95%E0%B8%A3%E0%B8%A5%E0%B8%B1%E0%B8%9A-23-%E0%B8%A7%E0%B8%B4%E0%B8%98%E0%B8%B5%E0%B9%80%E0%B8%8A%E0%B9%87%E0%B8%84-conversion-%E0%B8%A3%E0%B8%B9%E0%B9%89%E0%B8%97%E0%B8%B1/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_04'),
          subtitle: this.$t('growthtool_subtitle_04'),
          image: '/static/img/assets/growthtool/Growth_tools_04.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_13.jpg',
          description: {
            title: this.$t('growthtool_description_title_04'),
            text: this.$t('growthtool_description_text_04'),
            text1: this.$t('growthtool_description_text1_04'),
            text2: this.$t('growthtool_description_text2_04'),
            text3: this.$t('growthtool_description_text3_04'),
            packageText: this.$t('growthtool_description_packageText_04')
          },
          url:
            'https://blog.zwiz.app/%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B9%80%E0%B8%A7%E0%B9%87%E0%B8%9A%E0%B8%82%E0%B8%B2%E0%B8%A2%E0%B8%82%E0%B8%AD%E0%B8%87/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_03'),
          subtitle: this.$t('growthtool_subtitle_03'),
          image: '/static/img/assets/growthtool/Growth_tools_06.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_16.jpg',
          description: {
            title: this.$t('growthtool_description_title_03'),
            text: this.$t('growthtool_description_text_03'),
            text1: this.$t('growthtool_description_text1_03'),
            packageText: this.$t('growthtool_description_packageText_03')
          },
          url:
            'https://blog.zwiz.app/follow-up-%E0%B8%95%E0%B8%B2%E0%B8%A1%E0%B8%A5%E0%B8%B9%E0%B8%81%E0%B8%84%E0%B9%89%E0%B8%B2%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%81%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B8%A1%E0%B8%B2%E0%B8%8B%E0%B8%B7%E0%B9%89/?utm_source=Growthtool'
        },
        {
          title: this.$t('growthtool_title_02'),
          subtitle: this.$t('growthtool_subtitle_02'),
          image: '/static/img/assets/growthtool/Growth_tools_09.jpg',
          imageEng: '/static/img/assets/growthtool/Growth_tools_17.jpg',
          description: {
            title: this.$t('growthtool_description_title_02'),
            text: this.$t('growthtool_description_text_02'),
            text1: this.$t('growthtool_description_text1_02'),
            packageText: this.$t('growthtool_description_packageText_02'),
            imageText: this.$t('growthtool_description_imageText_02'),
            isShowRefLink: true
          },
          url:
            'https://blog.zwiz.app/%E0%B8%AA%E0%B8%B9%E0%B8%95%E0%B8%A3%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B9%81%E0%B8%8A%E0%B8%97%E0%B8%9A%E0%B8%AD%E0%B8%97-002/?utm_source=Growthtool'
        }
      ]
    }
  },
  mounted() {
    // this.$store.dispatch('loadIntent')
  },
  methods: {
    onCopy: function() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onSelect(param) {
      this.intentSelect = param
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/growthTool/GrowthTool.vue